/* eslint-disable no-debugger */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILobasArticleData } from './lobas-article.data';
import { ILobasArticleProps } from './lobas-article.props.autogenerated';
import { IArticleViewProps } from './components/articleView';
//import { IArticle } from '../../actions/DataServiceEntities.g';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';

export interface ILobasArticleViewProps extends ILobasArticleProps<ILobasArticleData> {
    articleViewProps: IArticleViewProps;
    articleProps: IModuleProps;
}

/*export interface ILobasArticleState {
    article: IArticle | undefined;
}*/
/**
 *
 * LobasArticle component
 * @extends {React.PureComponent<ILobasArticleProps<ILobasArticleData>>}
 */
class LobasArticle extends React.PureComponent<ILobasArticleProps<ILobasArticleData> /*, ILobasArticleState*/> {
    public constructor(props: ILobasArticleProps<ILobasArticleData> /*, state: ILobasArticleState*/) {
        super(props);
        //this.state = { article: undefined };
    }

    /*public componentDidMount() {
        void this.props.data.articles.then(res => {
            console.log(res);

            const article = res;

            if (res) {
                this.setState({ article: article });
            }
        });
    }*/

    public render(): JSX.Element | null {
        if (!this.props.data.articles.result) {
            return null;
        }

        const viewProps = {
            ...this.props,
            articleViewProps: {
                article: this.props.data.articles.result,
                locale: this.props.context.request.locale,
                resources: this.props.resources,
                className: this.props.config.className,
                context: this.props.context
            },
            articleProps: {
                moduleProps: this.props,
                className: '',
                tag: 'div'
            }
        };

        return this.props.renderView(viewProps);
    }
}

export default LobasArticle;
